import type { HubTheme } from "../hub-theme.types";

const RAINBOW =
  "linear-gradient(90deg, #2AACE2 0%, #91288D 28%, #E72B45 55%, #F18230 78%, #FFC82C 100%)";

export const novaHubTheme: HubTheme = {
  wordmark: "NOVA",
  wordmarkLabel: "Nova",
  pageBackground: "#1C1B1C",

  heroBg: "linear-gradient(180deg, #393939 0%, #222221 50%)",
  heroStripe: RAINBOW,
  heroGlow:
    "radial-gradient(closest-side, rgba(140,121,88,0.32) 0%, rgba(140,121,88,0) 70%)",
  greetingText: "#EEE1CA",
  nameText: "#FFFFFF",
  pillBg: "rgba(238,225,202,0.10)",
  pillBorder: "rgba(238,225,202,0.22)",
  pillText: "#EEE1CA",
  codeText: "rgba(255,255,255,0.62)",
  watermark: "rgba(238,225,202,0.08)",

  avatarRing: "linear-gradient(135deg, #8C7958 0%, #EEE1CA 100%)",
  avatarInnerBg: "linear-gradient(135deg, #2C2B2A 0%, #1C1B1C 100%)",
  avatarText: "#EEE1CA",

  loyaltyStripBg: "rgba(255,255,255,0.04)",
  loyaltyStripBorder: "rgba(255,255,255,0.08)",
  loyaltyFill: "linear-gradient(90deg, #8C7958 0%, #A38C66 100%)",
  loyaltyText: "#FFFFFF",
  loyaltyMuted: "rgba(255,255,255,0.62)",

  surface: "#222221",
  surface2: "#2C2B2A",
  tileBg: "#393939",
  fg: "#FFFFFF",
  fgSoft: "#EEE1CA",
  muted: "#C7C6C6",
  muted2: "#979797",
  border: "#2C2B2A",
  borderSoft: "#2C2B2A",

  brand: "#8C7958",
  brandSoft: "#2C261A",
  brandStrong: "#A38C66",
  cream: "#EEE1CA",
  gradient: RAINBOW,
  qrIconBg: "#8C7958",
  memStripe: "linear-gradient(180deg, #8C7958 0%, #EEE1CA 100%)",

  eyebrowRule: "#8C7958",
  eyebrowText: "#EEE1CA",
  metaText: "#EEE1CA",
  metaBg: "#2C261A",
  metaBorder: "#3A3220",

  danger: "#FF4D5A",
  dangerSoft: "#3A0F12",
  star: "#FFC82C",
  success: "#33B15B",
  successSoft: "#1B3A23",
  warning: "#ED6C02",
  warningSoft: "#3A2810",
  cardShadow:
    "0 1px 0 rgba(255,255,255,0.04) inset, 0 2px 10px rgba(0,0,0,0.30)",
  ctaShadow: "0 6px 18px rgba(140,121,88,0.35)",
  heroShadow:
    "0 1px 0 rgba(255,255,255,0.06) inset, 0 14px 32px -8px rgba(0,0,0,0.55)",
  heroBorder: "rgba(255,255,255,0.05)",
  avatarShadow:
    "0 8px 22px rgba(140,121,88,0.30), inset 0 1px 0 rgba(255,255,255,0.20)",

  activityIcons: [
    {
      bg: "#8C7958",
      color: "#fff",
      shadow: "0 8px 24px rgba(140,121,88,0.28)",
    },
    { bg: "linear-gradient(135deg, #8C7958 0%, #5C4F38 100%)", color: "#fff" },
    { bg: "#2C261A", color: "#EEE1CA" },
    { bg: "#393939", color: "#EEE1CA" },
  ],
};
